<template>
  <div class="vendor-payment full-width q-pt-xl">
    <div class="text-body-3 text-secondary-5">Payment</div>
    <div class="line"></div>

    <Grid gtc="auto 1fr" class="q-py-sp q-px-lg">
      <Grid gtc="1fr auto" gap="var(--r-space-sm)" align-items="center">
        <div class="text-body-1 text-secondary-5">Payment number:</div>
        <div class="text-body-3 text-secondary-5">{{ data.payment_number || 'N/A' }}</div>

        <div class="text-body-1 text-secondary-5">Reference:</div>
        <div class="text-body-3 text-secondary-5">{{ data.reference || 'N/A' }}</div>

        <div class="text-body-1 text-secondary-5">Payment date:</div>
        <div class="text-body-3 text-secondary-5">{{ formatDateForLocale(data.payment_date) || 'N/A' }}</div>
      </Grid>

      <Grid style="justify-self: end; align-self: end">
        <div class="text-body-3 text-secondary-5 text-right">Paid:</div>
        <div class="text-heading-1 text-secondary-5">
          <small>{{ data.currency }}</small>
          {{ data.paid_amount ? formatPrice(data.paid_amount, 2) : '-' }}
        </div>
        <span class="text-caption-1 text-grey3 text-right">
          Exchange rate: {{ data.exchange_rate ? formatPrice(data.exchange_rate, 4) : '-' }}
        </span>
      </Grid>
    </Grid>

    <div class="line"></div>

    <GridTable v-if="data.items" :columns="columns" :rows="data.items" style="width: 400px">
      <template #row="{row}">
        <GridTableCell class="text-right">{{ row.currency }} {{ formatPrice(row.price) }}</GridTableCell>
        <GridTableCell class="text-right">{{ row.paid_currency }} {{ formatPrice(row.paid_amount) }}</GridTableCell>
      </template>
    </GridTable>
  </div>
</template>

<script>
import GridTable from '@/reusable/grid-table/GridTable'
import GridTableCell from '@/reusable/grid-table/GridTableCell'

export default {
  components: {
    GridTable,
    GridTableCell
  },

  props: {
    data: {
      type: Object,
      required: true
    }
  },

  computed: {
    columns() {
      return [
        { label: 'Price', width: '1fr', align: 'right' },
        { label: 'Paid Amount', width: '1fr', align: 'right' }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.vendor-payment {
  .line {
    height: 1px;
    width: 100%;
    background: var(--r-secondary-5);
  }
}
</style>
